module.exports = __webpack_public_path__ + "img/statistic.ee2d9b20.svg";